
import { Vue } from "vue-class-component"

class Props {
    productText?: string;
    availableText?: string;
}
export default class ProductSection extends Vue.with(Props) {}
